import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=c567e5f4"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports